import React, { useEffect } from 'react';
import { useScrollIndicators } from '../hooks/useScrollIndicators';
import ScrollIndicators from './ScrollIndicators';

const PageWrapper = ({ children, maxWidth = "700px", as: Component = "main", className }) => {
  const { showScrollFade, scrollProgress } = useScrollIndicators();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <>
      <ScrollIndicators scrollProgress={scrollProgress} showScrollFade={showScrollFade} />
      <Component className={className} style={{
        maxWidth, 
        margin: "auto", 
        textAlign: "left", 
        fontFamily: "Arial, sans-serif",
        position: "relative",
        paddingBottom: "80px"
      }}>
        {children}
      </Component>
    </>
  );
};

export default PageWrapper;
